import MenuButton from 'components/MenuButton'
import NavLink from 'components/NavLink'
import { useNavbar } from 'context/navbar-context'
import { useUser } from 'context/user-context'
import useOnClickOutside from 'hooks/useOnClickOutside'
import Guigo from 'images/guigo.svg'
import GuigoPartner from 'images/guigo_partners.svg'
import React, { Fragment, useRef } from 'react'
import { Container, ItemLabel, Logo, Menu, MenuItem, NavigationDiv, OptionsContainer } from './styles'

const LogoPath = () => {
  const { user } = useUser()
  return user.company_name ? GuigoPartner : Guigo
}

const MenuLinks = () => {
  const { user } = useUser()

  if (user.company_name) {
    return (
      <Fragment>
        <MenuItem>
          <OptionsContainer flexDirection='column' ml={16} isOpen={true}>
            <NavLink to='/prepaid-purchase/my-packages/list'>
              <ItemLabel>Meus Pacotes</ItemLabel>
            </NavLink>
            <NavLink to='/prepaid-purchase/beneficiaries'>
              <ItemLabel>Beneficiários</ItemLabel>
            </NavLink>
            <NavLink to='/prepaid-purchase/groups'>
              <ItemLabel>Grupos</ItemLabel>
            </NavLink>
            <NavLink to='/prepaid-purchase/gift-cards'>
              <ItemLabel>Cartões Presente</ItemLabel>
            </NavLink>
            <NavLink to='/prepaid-purchase/my-packages/order-history'>
              <ItemLabel>Pedidos Realizados</ItemLabel>
            </NavLink>
            <NavLink to='/prepaid-purchase/catalog'>
              <ItemLabel>Imagens para Divulgação</ItemLabel>
            </NavLink>
          </OptionsContainer>
        </MenuItem>
      </Fragment>
    )
  } else {
    return (
      <>
        <MenuItem>
          <NavigationDiv>Promoções</NavigationDiv>
          <OptionsContainer flexDirection='column' ml={16} isOpen={true}>
            <NavLink to='/staff/promotions/coupons'>Cupons</NavLink>
          </OptionsContainer>
        </MenuItem>

        <MenuItem>
          <NavigationDiv>Parceiros Pré Pago</NavigationDiv>
          <OptionsContainer flexDirection='column' ml={16} isOpen={true}>
            <NavLink to='/staff/partners/pre-registrations'>Pré Cadastros</NavLink>
            <NavLink to='/staff/partners/list'>Lista de Parceiros</NavLink>
            <NavLink to='/staff/prepaid-partners/gift-card'>Cartões presente</NavLink>
            <NavLink to='/staff/prepaid-partners/purchase-history'>Histórico de compras</NavLink>
            <NavLink to='/staff/prepaid-partners/beneficiaries'>Beneficiários</NavLink>
            <NavLink to='/staff/prepaid-partners/packages'>Pacotes</NavLink>
          </OptionsContainer>
        </MenuItem>
      </>
    )
  }
}

const Sidebar = ({ showSidebar, updateSidebar }) => {
  const { isNavbarOpenOnMobile, setIsNavbarOpenOnMobile } = useNavbar()
  const sidebarRef = useRef()

  useOnClickOutside(sidebarRef, () => {
    updateSidebar(false)
  })

  return (
    <Container ref={sidebarRef} isOpenOnMobile={isNavbarOpenOnMobile} showSidebar={showSidebar}>
      <MenuButton
        handleClick={() => {
          setIsNavbarOpenOnMobile(!isNavbarOpenOnMobile)
          updateSidebar()
        }}
        variant='close'
        position='absolute'
        top='24px'
        right='24px'
        display={['initial', 'initial', 'none']}
      />
      <Logo src={LogoPath()} />
      <Menu>
        <MenuLinks />
      </Menu>
    </Container>
  )
}
export default Sidebar
